import React from 'react'
import {ContextLoader}  from './../../utils/import.frames'

interface Properties{
    payload?: any
    handleImageClick?: any
}

const GalleryCompontn = (property: Properties) => {
    if (ContextLoader.hasOwnProperty(property.payload)){
        var images = ContextLoader[property.payload]()
        return(
            images.map((image: any, index: number) =>
                <img key = {index} src = {image} className ="gallery-img" onClick = {() => property.handleImageClick(image, index, property.payload)} alt=''></img>
        )
        )
    }
        
}

export default GalleryCompontn